module.exports = __webpack_public_path__ + "img/27_4.d7eb6cb1.png";